export const INSTRUCTOR_PROFILE_UPDATE = "INSTRUCTOR_PROFILE_UPDATE";

export const INSTRUCTOR_PASSWORD_RESET =  "INSTRUCTOR_PASSWORD_RESET";

export const GET_INSTRUCTOR_DETAILS = "GET_INSTRUCTOR_DETAILS"; 